import React, { useContext, useState, useEffect } from "react";
import './SubcategoriesForm.css';

import axios from "axios";
import { HerracContext } from "../../App";

function AutomobileForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const { fuelTypeData } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🚗 AutomobileForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  // 🔹 subCategoryId dəyişildikdə uyğun Brand-ləri gətir
  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for subcategory:', subCategoryId);
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  // 🔹 Brand seçildikdə uyğun Model-ləri gətir
  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: value,
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="automobileForm">
      {/* Marka seçimi */}
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Avtomobil istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          disabled={filteredBrands.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands?.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      {/* Model seçimi */}
      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Avtomobil modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          disabled={filteredModels.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Buraxılış ili <span>*</span>
          <span className="tooltip-icon" title="İstehsal ili">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="year" 
          min="1900" 
          max={currentYear} 
          placeholder={currentYear.toString()}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Yanacaq növü <span>*</span>
          <span className="tooltip-icon" title="Mühərrikin yanacaq tipi">ℹ️</span>
        </h3>
        <select name="fuelTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {fuelTypeData.map((fuelType) => (
            <option key={fuelType.id} value={fuelType.id}>{fuelType.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Yürüş (km) <span>*</span>
          <span className="tooltip-icon" title="Ümumi yürüş">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="mileage" 
          min={0} 
          placeholder="150000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Sürət qutusu <span>*</span>
          <span className="tooltip-icon" title="Transmissiya tipi">ℹ️</span>
        </h3>
        <select name="transmission" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Avtomat">Avtomat (Automatic)</option>
          <option value="Mexanik">Mexanik (Manual)</option>
          <option value="Robot">Robot</option>
          <option value="Variator">Variator (CVT)</option>
        </select>
      </div>

      <div>
        <h3>
          Mühərrik həcmi (L) <span>*</span>
          <span className="tooltip-icon" title="Litr ilə">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1"
          name="engineVolume" 
          placeholder="2.0"
          min="0.5"
          max="10"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik gücü (a.g.) <span>*</span>
          <span className="tooltip-icon" title="At gücü (HP)">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="enginePower" 
          placeholder="150"
          min="30"
          max="2000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Ötürücü tipi <span>*</span>
          <span className="tooltip-icon" title="Drive type">ℹ️</span>
        </h3>
        <select name="driveType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Ön">Ön (Front)</option>
          <option value="Arxa">Arxa (Rear)</option>
          <option value="Tam">Tam (AWD/4WD)</option>
        </select>
      </div>

      <div>
        <h3>
          Ban növü <span>*</span>
          <span className="tooltip-icon" title="Body type">ℹ️</span>
        </h3>
        <select name="bodyType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Sedan">Sedan</option>
          <option value="Hatchback">Hatchback</option>
          <option value="SUV">SUV</option>
          <option value="Crossover">Crossover</option>
          <option value="Coupe">Coupe</option>
          <option value="Universal">Universal (Wagon)</option>
          <option value="Minivan">Minivan</option>
          <option value="Pickup">Pickup</option>
          <option value="Kabriolet">Kabriolet</option>
          <option value="Liftback">Liftback</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Kuzov rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Ağ, Qara, Gümüşü..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Oturacaq sayı <span>*</span>
          <span className="tooltip-icon" title="İçəridəki oturacaq">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="seatCount" 
          min={1} 
          max={9}
          placeholder="5"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Qapı sayı <span>*</span>
          <span className="tooltip-icon" title="Təkər qapıları daxil deyil">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="doorCount" 
          min={1} 
          max={6}
          placeholder="4"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Avtomobil yenidirmi? <span>*</span>
          <span className="tooltip-icon" title="0 km yenidirmi?">ℹ️</span>
        </h3>
        <select name="isNew" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (0 km)</option>
          <option value="false">Xeyr (İşlənmiş)</option>
        </select>
      </div>

      <div>
        <h3>
          Sahib sayı <span>*</span>
          <span className="tooltip-icon" title="Neçənci sahibdir?">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="ownerCount" 
          min={0} 
          max={10}
          placeholder="1"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Texniki baxışdan keçib? <span>*</span>
          <span className="tooltip-icon" title="Technical inspection">ℹ️</span>
        </h3>
        <select name="hasTechnicalInspection" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Sığorta var? <span>*</span>
          <span className="tooltip-icon" title="Insurance">ℹ️</span>
        </h3>
        <select name="hasInsurance" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Qəzalı olub? <span>*</span>
          <span className="tooltip-icon" title="Qəza keçirib?">ℹ️</span>
        </h3>
        <select name="isAccidented" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ⚠️</option>
          <option value="false">Xeyr ✅</option>
        </select>
      </div>

      <div>
        <h3>
          VIN nömrəsi <span>*</span>
          <span className="tooltip-icon" title="17 simvollu unikal kod">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="vin" 
          placeholder="1HGBH41JXMN109186"
          maxLength={17}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Bazar tipi (ölkə) <span>*</span>
          <span className="tooltip-icon" title="Hansı bazar üçün istehsal olunub">ℹ️</span>
        </h3>
        <select name="marketCountry" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Azərbaycan">Azərbaycan</option>
          <option value="Almaniya">Almaniya</option>
          <option value="Amerika">Amerika (ABŞ)</option>
          <option value="Yaponiya">Yaponiya</option>
          <option value="Koreya">Cənubi Koreya</option>
          <option value="Türkiyə">Türkiyə</option>
          <option value="Rusiya">Rusiya</option>
          <option value="Gürcüstan">Gürcüstan</option>
          <option value="Çin">Çin</option>
          <option value="Avropa">Avropa (Digər)</option>
          <option value="Digər">Digər</option>
        </select>
      </div>
    </div>
  );
}

export default AutomobileForm;